import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, ArrowUpCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { useTenantPlan } from "@/hooks/useTenantPlan";

export function TrialExpiryBanner() {
  const { isTrialing, daysUntilExpiry } = useTenantPlan();
  const navigate = useNavigate();

  useEffect(() => {
    if (isTrialing && daysUntilExpiry !== null && daysUntilExpiry <= 0) {
      navigate("/acesso-bloqueado?reason=trial_expired");
    }
  }, [isTrialing, daysUntilExpiry, navigate]);

  if (!isTrialing || daysUntilExpiry === null || daysUntilExpiry > 7 || daysUntilExpiry <= 0) {
    return null;
  }

  return (
    <Alert className="rounded-none border-x-0 border-t-0 border-amber-500/50 bg-amber-50 dark:bg-amber-950/30">
      <AlertTriangle className="h-4 w-4 text-amber-600" />
      <AlertDescription className="flex items-center justify-between gap-4">
        <span className="text-amber-800 dark:text-amber-200">
          Seu trial expira em <strong>{daysUntilExpiry} {daysUntilExpiry === 1 ? "dia" : "dias"}</strong>. Faça upgrade para continuar usando todas as funcionalidades.
        </span>
        <Button
          size="sm"
          variant="outline"
          className="shrink-0 border-amber-500 text-amber-700 hover:bg-amber-100 dark:text-amber-200"
          onClick={() => navigate("/app/minha-conta")}
        >
          <ArrowUpCircle className="mr-1 h-3.5 w-3.5" />
          Fazer upgrade
        </Button>
      </AlertDescription>
    </Alert>
  );
}
